import { unescape } from 'lodash-es';

export function setLocalizationLangCd(lang) {
  localStorage.setItem('localizationLanguageCd', lang);
}

export function getLocalizationLangCd(isLocalizationEnabled, supportedLanguages = ['en', 'ja']) {
  let localizationLanguageCd = 'en';
  function getNavigatorLanguage() {
    const languageBrowser = navigator.language.split('-');
    if (languageBrowser[0] === 'zh') {
      return `${languageBrowser[0]}-${languageBrowser[1]}`;
    }
    return languageBrowser[0];
  }
  if (!isLocalizationEnabled) {
    localizationLanguageCd = null;
    return localizationLanguageCd;
  }
  if (localStorage.getItem('localizationLanguageCd') != null) {
    localizationLanguageCd = localStorage.getItem('localizationLanguageCd');
  } else if (navigator.language != null) {
    localizationLanguageCd = getNavigatorLanguage();
    if (!supportedLanguages?.includes(localizationLanguageCd)) {
      // For now we support only en and ja login translation
      localizationLanguageCd = 'en';
    }
  }
  return localizationLanguageCd;
}

// see: https://github.com/i18next/react-i18next/issues/964.
// TLDR; Trans component uses a parser to detect and assume <*> are DOM nodes.
// Handles situations where userName is something like: "<Prerna> <Sharma>".
// Note: Trans/React seems to be handling XSS vulnerability, tested '<script>alert("get rekt")</script>'
// TODO we can convert this to a utility, but don't want to promote this as such rn.
export const getUnescapeChildrenRef = (ref) => {
  if (ref?.childNodes) {
    Array.from(ref.childNodes).forEach((node) => {
      if (!node.innerText) {
        return node;
      }
      // eslint-disable-next-line no-param-reassign
      node.innerText = unescape(node.innerText);
      return node;
    });
  }
  return ref;
};

/**
 * Given a labels object with { label: defaulttext, ...}
 * It returns an object with { label: t(label) || defaulttext, ...}
 * @param {Object} labels
 * @param {function} t
 * @returns {Object}
 */
export const getTranslationsFromLabelsObject = (labels, t) => {
  const i18nMap = Object.keys(labels).reduce((acc, curr) => {
    acc[curr] = t(curr);
    return acc;
  }, {});
  return i18nMap;
};
